// import {
//     createSelector,
//     createEntityAdapter
// } from "@reduxjs/toolkit";
// import { apiSlice } from "../../app/api/apiSlice"

// const usersAdapter = createEntityAdapter({})

// const initialState = usersAdapter.getInitialState()

// export const usersApiSlice = apiSlice.injectEndpoints({
//     endpoints: builder => ({
//         getUsers: builder.query({
//             query: () => ({
//                 url: '/users',
//                 validateStatus: (response, result) => {
//                     return response.status === 200 && !result.isError
//                 },
//             }),
//             transformResponse: responseData => {
//                 const loadedUsers = responseData.map(user => {
//                     user.id = user._id
//                     return user
//                 });
//                 return usersAdapter.setAll(initialState, loadedUsers)
//             },
//             providesTags: (result, error, arg) => {
//                 if (result?.ids) {
//                     return [
//                         { type: 'User', id: 'LIST' },
//                         ...result.ids.map(id => ({ type: 'User', id }))
//                     ]
//                 } else return [{ type: 'User', id: 'LIST' }]
//             }
//         }),
//         addNewUser: builder.mutation({
//             query: initialUserData => ({
//                 url: '/users',
//                 method: 'POST',
//                 body: {
//                     ...initialUserData,
//                 }
//             }),
//             invalidatesTags: [
//                 { type: 'User', id: "LIST" }
//             ]
//         }),
//         updateUser: builder.mutation({
//             query: initialUserData => ({
//                 url: '/users',
//                 method: 'PATCH',
//                 body: {
//                     ...initialUserData,
//                 }
//             }),
//             invalidatesTags: (result, error, arg) => [
//                 { type: 'User', id: arg.id }
//             ]
//         }),
//         deleteUser: builder.mutation({
//             query: ({ id }) => ({
//                 url: `/users`,
//                 method: 'DELETE',
//                 body: { id }
//             }),
//             invalidatesTags: (result, error, arg) => [
//                 { type: 'User', id: arg.id }
//             ]
//         }),
//     }),
// })

// export const {
//     useGetUsersQuery,
//     useAddNewUserMutation,
//     useUpdateUserMutation,
//     useDeleteUserMutation,
// } = usersApiSlice

// // returns the query result object
// export const selectUsersResult = usersApiSlice.endpoints.getUsers.select()

// // creates memoized selector
// const selectUsersData = createSelector(
//     selectUsersResult,
//     usersResult => usersResult.data // normalized state object with ids & entities
// )

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//     selectAll: selectAllUsers,
//     selectById: selectUserById,
//     selectIds: selectUserIds
//     // Pass in a selector that returns the users slice of state
// } = usersAdapter.getSelectors(state => selectUsersData(state) ?? initialState)

import { apiSlice } from "../../app/api/apiSlice";

export const usersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // src/features/users/usersApiSlice.js
    getUsers: builder.query({
    query: (q = "") => `/users${q ? `?q=${encodeURIComponent(q)}` : ""}`,
    transformResponse: (res) => {
        if (Array.isArray(res)) return res;       // array directly
        if (Array.isArray(res?.users)) return res.users; // wrapped
        if (Array.isArray(res?.data)) return res.data;   // some APIs use data
        return []; // fallback
    },
    providesTags: (result = []) =>
        result.length
        ? [...result.map(({ _id }) => ({ type: "User", id: _id })), { type: "User", id: "LIST" }]
        : [{ type: "User", id: "LIST" }],
    }),

    // NEW: get a single user by id
    getUser: builder.query({
      query: (id) => `/users/${id}`,
      // handle both shapes: {user:{...}} or {...}
      transformResponse: (res) => (res?.user ? res.user : res),
      providesTags: (res, err, id) => [{ type: "User", id }],
    }),

    addUser: builder.mutation({
      query: (body) => ({ url: "/users", method: "POST", body }),
      invalidatesTags: [{ type: "User", id: "LIST" }],
    }),

    updateUser: builder.mutation({
      query: ({ id, ...patch }) => ({ url: `/users/${id}`, method: "PATCH", body: patch }),
      invalidatesTags: (res, err, { id }) => [{ type: "User", id }],
    }),
    
    deleteUser: builder.mutation({
      query: (id) => ({ url: `/users/${id}`, method: "DELETE" }),
      invalidatesTags: [{ type: "User", id: "LIST" }],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserQuery,          // <-- export the new hook
  useAddUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersApiSlice;
